
import SwitchCell from "@/components/table/cells/SwitchCell.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserConfiguration",
  components: { SwitchCell },
  data() {
    return {
      loading: false,
      showPassword: false,
      newNotify: false,
      oldpassword: "",
      password: "",
      repassword: "",
    };
  },

  computed: {
    ...mapGetters({
      loggedUser: "application/getLoggedUser",
    }),
    notify() {
      return this.loggedUser && this.loggedUser.config.notifications;
    },
    edited() {
      return (
        this.newNotify !== this.notify ||
        (this.showPassword === true &&
          this.oldpassword !== "" &&
          this.password !== "" &&
          this.repassword !== "")
      );
    },
  },

  created() {
    this.newNotify = this.notify;
  },

  methods: {
    ...mapActions({
      setUserNotifications: "application/setUserNotifications",
      renewUserPassword: "application/renewUserPassword",
    }),
    dispatchAction() {
      if (this.edited) {
        this.loading = true;
        const body = {
          notify: this.newNotify,
          changepassword: this.showPassword,
          oldpassword: this.oldpassword,
          password: this.password,
          repassword: this.repassword,
        };

        this.setUserNotifications(this.newNotify);
        if (this.showPassword) {
          this.renewUserPassword({ ...body, username: this.loggedUser.username });
        }
        this.loading = false;
      }
    },
    transitionEnter(el, done) {
      el.style.marginTop = `-${el.offsetHeight}px`;
      this.$velocity(
        el,
        { marginTop: "0px" },
        { duration: 250, easing: "ease-in-out", complete: done },
      );
    },
    transitionLeave(el, done) {
      this.$velocity(
        el,
        { marginTop: `-${el.offsetHeight}px` },
        { duration: 250, easing: "ease-in-out", complete: done },
      );
    },
  },
};
